import type { ReactNode } from "react";
import styled from "styled-components";

import { colors } from "../../../styles/figmaColors";
import { typographies } from "../../../styles/figmaTypographies";
import { StyledColumn, StyledFlex } from "./layout";
import { ChevronRightOutlined } from "../../materialUi/materialUi";
import { Spacer } from "../Spacer";
import { TextCapitalized } from "../text/TextCapitalized";

export interface ListRowProps {
  leftIcon: ReactNode;
  title: string;
  subtitle?: string;
  rightElement?: ReactNode;
  onClick?: () => void;
}

export const ListRow = ({
  leftIcon,
  title,
  subtitle,
  rightElement,
  onClick,
}: ListRowProps) => (
  <StyledRow
    as={onClick ? "button" : undefined}
    $isClickable={onClick !== undefined}
    onClick={onClick}
  >
    {leftIcon}
    <Spacer x={0.75} />
    <StyledContent>
      <TextCapitalized>
        <StyledTitle>{title}</StyledTitle>
      </TextCapitalized>
      {subtitle && (
        <>
          <Spacer y={0.25} />
          <TextCapitalized>
            <StyledSubtitle>{subtitle}</StyledSubtitle>
          </TextCapitalized>
        </>
      )}
    </StyledContent>
    {rightElement && (
      <>
        <Spacer x={0.75} />
        {rightElement}
      </>
    )}
    {onClick && (
      <>
        <Spacer x={0.75} />
        <StyledChevron />
      </>
    )}
  </StyledRow>
);

const StyledRow = styled(StyledFlex)<{ $isClickable?: boolean }>`
  /* Reset the native button chrome so spacing comes only from Spacer. */
  all: unset;
  display: flex;
  width: 100%;
  align-items: center;
  ${({ $isClickable }) => $isClickable && "cursor: pointer;"}
`;

// Takes the remaining width so the right element sits at the edge.
const StyledContent = styled(StyledColumn)`
  flex: 1;
`;

const StyledTitle = styled.span`
  ${typographies["Body/L"]}
  color: ${colors["colors/text/black"]};
`;

const StyledSubtitle = styled.span`
  ${typographies["Body/XS"]}
  color: ${colors["colors/text/lightGrey"]};
`;

const StyledChevron = styled(ChevronRightOutlined)`
  flex-shrink: 0;
  fill: ${colors["colors/text/lightGrey"]};
`;
